import React, {useState} from 'react'
import UiKit from "../../../../../common/uikit"
import parse from "react-html-parser"

const Edit = () => {
    const [data, setData] = useState("");
    const [lan, setLan] = useState();
    const languageOption = [
        {
            "text" : "türkçe",
            "value": 0
        },
        {
            "text" : "english",
            "value": 1
        },
    ]
    const languageOptions = () => {
        return languageOption.map(l => ({
            text    : l.text,
            value   : l.value 
        }))
    }
    return (
        <div className="add-blog-container"> 
        <div>
        <form className="form-wrapper">
                <UiKit.Row className="mt25">
                    <UiKit.Col className="p8" sm="12" md="12">
                        <UiKit.Textfield
                            full
                            required
                            placeholder = "blog title"
                            // value       = { s.form.website }
                            // onChange    = { value => changeFormValues('website', value) }
                            // errors      = { s.errors['website'] }
                            // isDisabled  = { redux.isLoading }
                            // attrs       = { { id: 'sign-up-website' } }
                        />
                    </UiKit.Col>
                </UiKit.Row>
                <UiKit.Row className="mt25">
                    <UiKit.Col className="p8"sm="6" md="6">
                        <div className="file-upload">
                            <input type="file" name="file"  placeholder="resim sec"/>
                        </div>
                    </UiKit.Col>
                    <UiKit.Col className="p8"sm="6" md="6">
                        <UiKit.Dropdown
                            full
                            required
                            placeholder  = "Dil Seçiniz"
                            options      = { languageOptions() }
                            onChange     = { ({ value }) => setLan(value) }
                            value        = { lan }
                            // errors       = { s.errors['revenueCenterId'] }
                            // attrs        = {{ id: 'reservation-request-revenue-center' }}
                        />
                    </UiKit.Col>
                </UiKit.Row>
            </form>
        </div>
            <div className="blog-text">
                <p>Blog detayi giriniz</p>
                <div className="editor">
                    <UiKit.Editor 
                        data    = {data}
                        edit    = { (value) => setData(value) }
                        plugIns = {[ 'key-binder' ]}
                    />
                </div>
            </div>
           <div className="show-wrapper">
                <h1>Son Haline Göz At 🧐</h1>
                <div className="show-blog">
                    {data && parse(data)}
                </div>
           </div>
           <div className="footer">
               <button>Güncelle</button>
           </div>
        </div>
    )
}

export default Edit
